import __request__ from "routing/request";
export function create(priority, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets/priorities", priority, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listPriorities(sort = "priority", page = 1, per_page = 15, query, direction = "desc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/assets/priorities", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/assets/priorities/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updatePriorities(priorities, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets/priorities/reprioritize", priorities, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, priority, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/assets/priorities/${id}`, priority, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/assets/priorities/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
